import http from "../../../../util/axios";

export default {
  //登录后的数据
  basicInfo(params) {
    return http.get("/app/user/center/basicInfo", { params });
  },
  //退出登录
  loginOut(params) {
    return http.get("/loginOut", { params });
  },
  //修改密码
  updatePassword(data){
    return http.post("/app/user/center/updatePassword",data);
  },
  //首页权限
  userIndex(params) {
    return http.get("/app/user/index", { params });
  },
  //切换项目
  switchLearn(params) {
    return http.get("/app/user/center/switchLearn", { params });
  },
  //申请证书
  applyCertificate(params) {
    return http.get("/app/user/applyCertificate", { params });
  },
  //获取语种
  langList(params) {
    return http.get("/lang/list", { params });
  },

  //课程列表
  classCourseList() {
    return http.post("/app/user/classCourse/courseList");
  },

  //课程直播（去上课）
  courseLive(params) {
    return http.get("/app/user/classCourse/courseLive", { params });
  },

  //课程加载页直播地址
  loadPageLiveUrl(params) {
    return http.get("/app/user/classCourse/loadPageLiveUrl", {params});
  },

  //查询课程回放列表
  playbackList() {
    return http.get("/app/user/classCourse/playbackList");
  },

  //查询课程回放
  coursePlayback(params) {
    return http.get("/app/user/classCourse/coursePlayback", { params });
  },

  //查询课程心跳
  courseHeartBeat(params){
    return http.get("/app/user/classCourse/courseHeartBeat", { params });
  },

  //通用心跳
  commomHeartBeat(url,params){
    return http.get(url, { params });
  },

  //记录视频学习时间
  recordVideoData(params){
    return http.get("/app/user/classCourse/record/video",{params});
  },

  //跳转到会议
  jumpMeeting(params){
    return http.get("/app/user/classCourse/jumpMeeting",{ params });
  },

  //查询录播课（去上课）
  courseRecord(params){
    return http.get("/app/user/classCourse/courseRecord",{ params });
  },

  //获取保利威播放凭证
  getPlaySafeToken(params){
    return http.get("/polyv/getPlaySafeToken",{ params });
  },

  //录播课实时上课学习,心跳每分钟1次
  realRecord(params){
    return http.get("/app/user/classCourse/realRecord",{ params });
  },
  //录播课实时考勤-上课期间 学员进出教室 actionType(In:进入; Out: 退出)
  courseRecordInOut(params){
    return http.get("/app/user/classCourse/courseRecordInOut",{params});
  }

};



// WEBPACK FOOTER //
// ./src/api/user/course/home/index.js